import * as React from 'react';
import Alert, { AlertProps } from '@material-ui/lab/Alert';

import AlertTitle, { AlertTitleProps } from '@material-ui/lab/AlertTitle';

import { withStyles } from '@material-ui/core';

const StyledDSAlert = withStyles({
    message: {
        flex: '1 1 0px',
        margin: 0,
        minWidth: 0,
    },
})(Alert);

export type DSAlertProps = AlertProps;

export const DSAlert: React.FC<DSAlertProps> = props => <StyledDSAlert {...props} />;

export type DSAlertTitleProps = AlertTitleProps;

export const DSAlertTitle: React.FC<AlertTitleProps> = props => <AlertTitle {...props} />;
